import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { usersApiSlice } from '../../features/user/usersApiSlice';
import socketSetup from '../../socket-io/socket-io';

export default function useStaffSocket() {

    const dispatch = useDispatch();

    const invalidateStaff = useCallback(() => {
        dispatch(
            usersApiSlice.util.invalidateTags([
                { type: "Staff", id: "LIST" },
            ])
        );
    }, [dispatch]);

    useEffect(() => {
        if (!socketSetup) return;

        socketSetup.on("staffRegister", invalidateStaff);
        socketSetup.on("updateStaff", invalidateStaff);
        socketSetup.on("updateStaffInfo", invalidateStaff);

        return () => {
            socketSetup.off("staffRegister", invalidateStaff);
            socketSetup.off("updateStaff", invalidateStaff);
            socketSetup.off("updateStaffInfo", invalidateStaff);
        };
    }, [invalidateStaff]);

    // const handleStaffRegistered = useCallback(() => {
    //     dispatch(
    //         usersApiSlice.util.invalidateTags([
    //             { type: "Staff", id: "LIST" },
    //         ])
    //     );
    // }, [dispatch]);

    // const handleStaffUpdated = useCallback(
    //     ({ staffId }: { staffId: number }) => {
    //         dispatch(
    //             usersApiSlice.util.invalidateTags([
    //                 { type: "Staff", id: staffId },
    //                 { type: "Staff", id: "LIST" },
    //             ])
    //         );
    //     },
    //     [dispatch]
    // );
    
    // useEffect(() => {
    //     if(!socketSetup) return
    //     socketSetup.on('staffRegistered', handleStaffRegistered)
    //     socketSetup.on('staffUpdated', handleStaffUpdated)

    //     return () => {
    //         socketSetup.off("staffRegistered", handleStaffRegistered);
    //         socketSetup.off("staffUpdated", handleStaffUpdated);
    //     }
    // }, [handleStaffRegistered, handleStaffUpdated])
}
